import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';

import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class LeadService extends HttpService {
  constructor(private httpClient: HttpClient, private store: Store) {
    super(environment.endpoints.newUser, httpClient, store);
  }

  sendEmail() {
    return this.getAsync();
  }

  sendEmailV2(token: string, planId: string) {
    const params = new HttpParams()
      .set('planName', planId);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params
    };
    httpOptions.headers = httpOptions.headers.set('Authorization', `Bearer ${token}`);
    return this.httpClient.get(`${environment.apiUrl}/v2/lead`, httpOptions).toPromise();
  }

  sendEmailNotAuthenticate(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    httpOptions.headers = httpOptions.headers.set('Authorization', `Bearer ${token}`);
    return this.getAsync('', httpOptions);
  }
}
